/**
 * @prettier
 * @flow
 */
import apisauce from 'apisauce';
import { terminalApiCode } from 'src/api/terminalApiCode';
import { terminalApiUrl } from 'src/api/terminalApiUrl';
import type { ApiSauceRequest } from 'src/api/types/ApiSauceRequest';
import type { ApiSauceResponse } from 'src/api/types/ApiSauceResponse';
import type { TerminalInstructionVm } from 'src/api/types/TerminalInstructionVm';
import type { GetWebhookResponseRequest } from 'src/api/types/terminalPosEmulatorApi/GetWebhookResponseRequest';
import { appVersion } from 'src/config/appVersion';
import { environment } from 'src/config/environment';
import type { Environment } from 'src/constants/Environment';

const REQUEST_METHODS_WITH_PARAMS = ['get', 'head', 'delete', 'link', 'unlink'];

function createTerminalPosApi(environment: Environment) {
    const baseURL = `${terminalApiUrl(environment)}/api/posEmulator`;

    const api = apisauce.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 60000, // 60 second timeout
    });

    if (process.env.NODE_ENV === 'development') {
        api.addRequestTransform(request => {
            const other = {};
            // if (request.headers) {
            //     other.headers = request.headers;
            // }
            if (request.params) {
                other.params = request.params;
            }
            if (request.data) {
                other.data = request.data;
            }
            console.log(`${request.method.toUpperCase()} ${baseURL}${request.url}`, other);
        });
        api.addMonitor((response) => {
            console.log(`${response.status} <- ${response.config.url}`, response.data);
        });
    }

    api.addRequestTransform(request => {
        if (REQUEST_METHODS_WITH_PARAMS.includes(request.method)) {
            if (!request.params) request.params = {};
            request.params.appVersion = appVersion;
        } else {
            if (!request.data) request.data = {};
            if (!request.params) request.params = {};
            request.data.appVersion = appVersion;
        }
    });

    return {
        config: api,
        getWebhookResponse: (request: ApiSauceRequest<GetWebhookResponseRequest>): ApiSauceResponse<TerminalInstructionVm | void> => {
            const { environment, serverUrl, ...req } = request;
            return api.post('api/posEmulator/getWebhookResponse', req, { baseURL: serverUrl, params: { code: terminalApiCode(environment) } });
        },

    };
}

export const terminalPosEmulatorApi = createTerminalPosApi(environment);
